<template>
  <data-list
    ref="dataList"
    class="content"
    add-btn="添加"
    name="账号"
    hide-audit
    :url="url"
    :query="query"
    :rules="rules"
    :custom-url="customUrl"
    :action-width="200"
    :modal-width="480"
    :modal-form="modalForm"
    :search-key-type="{name: 1}"
    :columns="columns">
    <template v-slot:title="{total}">
      <span>登记列表（共{{total}}条记录）</span>
    </template>
    <template v-slot:query="{form}">
      <a-form-model-item label="">
        <a-input-search v-model="form.keyword" placeholder="输入姓名/手机号码查询" @search="getList"></a-input-search>
      </a-form-model-item>
    </template>
    <template v-slot:edit="{form}">
      <a-form-model-item label="姓名" prop="name">
        <a-input v-model="form.name" placeholder="请输入姓名"></a-input>
      </a-form-model-item>
      <a-form-model-item label="手机号" prop="mobile">
        <a-input v-model="form.mobile" placeholder="请输入手机号"></a-input>
      </a-form-model-item>
      <a-form-model-item label="角色" prop="role_id">
        <a-select v-model="form.role_id" placeholder="请选择角色" :options="roleOptions"></a-select>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>

    export default {
        name: "Admin",
        data() {
            return {
                url: "/admin/admin",
                query: "&expand=role",
                columns: [
                    { title: '姓名', dataIndex: 'name' },
                    { title: '手机号', dataIndex: 'mobile' },
                    { title: '角色', dataIndex: 'role', customRender: text => text ? text.name : "--" },
                ],
                rules: {
                    name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                    mobile: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    role_id: [{required: true, message: '请选择角色', trigger: 'change'}],
                },
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                roleOptions: []
            }
        },
        created() {
            this.getRoleList();
        },
        methods: {
            getRoleList() {
                this.$axios(`/admin/role?pageSize=100`).then(res => {
                    this.roleOptions = res.data.map(item => {
                        return {
                            value: item.id,
                            label: item.name
                        }
                    })
                });
            },
            customUrl(url, form) {
                let res = "";
                if(form.keyword) {
                    res += `&filter[or][0][name][like]=${form.keyword}&filter[or][1][mobile][like]=${form.keyword}`;
                }
                return res;
            },
            getList() {
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped>

</style>
